module.exports = __webpack_public_path__ + "img/circle1.ea2ba532.svg";